import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import {
  Fab,
  Card,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import api from "../../../components/services/api";
import SearchData from "../components/SearchData";
import DowloadBT from "../components/dowloadBT";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import { red } from "@mui/material/colors";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShareIcon from "@mui/icons-material/Share";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ChartContainer from "../components/ChartContainer";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import { ResponsiveBar } from "@nivo/bar";
import {
  GridToolbarContainer,
  GridToolbarExport,
  gridClasses,
} from "@mui/x-data-grid";
import Chip from "@mui/material/Chip";
import moment from "moment";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import PieChart from "highcharts-react-official";
import SearchIcon from "@mui/icons-material/Search";
import icon1 from "../../../images/approved_11624425.png";
import icon2 from "../../../images/container_7486633.png";
import icon3 from "../../../images/forklift_6414339.png";
import icon4 from "../../../images/container-truck_11624489.png";
import icon5 from "../../../images/shipping_6414057.png";
import DatePicker from "@mui/lab/DatePicker";
import { useHistory } from "react-router-dom";

Highcharts.setOptions({
  lang: {
    thousandsSep: ",",
  },
});
export default function Dashboard() {
  const history = useHistory();
  const [startDate, setStartDate] = useState(moment(new Date()).add(-3, "M"));
  const [endDate, setEndDate] = useState(new Date());
  const [key, setKey] = useState();
  const [overallSummary, setOverallSummary] = useState();
  const [stockContainer, setStockContainer] = useState([]);
  const [workOrder, setWorkOrder] = useState();
  const [overallBooking, setOverallBooking] = useState([]);
  const userName = localStorage.getItem("userName");
  const [toOutboundCountry, setToOutboundCountry] = useState("all");
  const [toOutboundLocation, setToOutboundLocation] = useState("all");
  const [toInboundCountry, setToInboundCountry] = useState("all");
  const [toInboundLocation, setToInboundLocation] = useState("all");
  const [location, setLocation] = useState([]);
  const [locationOutboundFilter, setLocationOutboundFilter] = useState([]);
  const [locationInboundFilter, setLocationInboundFilter] = useState([]);
  const [country, setCountry] = useState([]);
  const [toAction, setToAction] = useState("all");
  const [board, setBoard] = useState("all");
  const [value, setValue] = useState(new Date());
  const [year, setYear] = useState(new Date());
  const [date, setDate] = useState(new Date());
  const [forecast, setForecast] = useState([]);
  const [revenueAndExpense, setRevenueAndExpense] = useState([]);
  const [revenueByType, setRevenueByType] = useState([]);
  const [type, setType] = useState("");

  const hexChars = "23456789ABD";
  const getRandomColor = () =>
    `#${Array.from({ length: 6 })
      .map(() => hexChars[Math.floor(Math.random() * 11)])
      .join("")}`;

  const data = overallBooking?.map((x) => {
    return {
      Month: x?.MonthName + " " + x?.Year,
      Truck: x?.Truck,
      Train: x?.Train,
      Ship: x?.Ship,
      Repair: x?.Repair,
    };
  });
  // [
  //   {
  //     "country": "AD",
  //     "hot dog": 139,
  //     "hot dogColor": "hsl(82, 70%, 50%)",
  //     "burger": 127,
  //     "burgerColor": "hsl(325, 70%, 50%)",
  //     "sandwich": 56,
  //     "sandwichColor": "hsl(263, 70%, 50%)",
  //     "kebab": 127,
  //     "kebabColor": "hsl(342, 70%, 50%)",
  //     "fries": 193,
  //     "friesColor": "hsl(338, 70%, 50%)",
  //     "donut": 70,
  //     "donutColor": "hsl(244, 70%, 50%)"
  //   },
  //   {
  //     "country": "AE",
  //     "hot dog": 197,
  //     "hot dogColor": "hsl(282, 70%, 50%)",
  //     "burger": 95,
  //     "burgerColor": "hsl(286, 70%, 50%)",
  //     "sandwich": 47,
  //     "sandwichColor": "hsl(36, 70%, 50%)",
  //     "kebab": 144,
  //     "kebabColor": "hsl(340, 70%, 50%)",
  //     "fries": 8,
  //     "friesColor": "hsl(268, 70%, 50%)",
  //     "donut": 191,
  //     "donutColor": "hsl(150, 70%, 50%)"
  //   },
  //   {
  //     "country": "AF",
  //     "hot dog": 128,
  //     "hot dogColor": "hsl(58, 70%, 50%)",
  //     "burger": 162,
  //     "burgerColor": "hsl(286, 70%, 50%)",
  //     "sandwich": 87,
  //     "sandwichColor": "hsl(256, 70%, 50%)",
  //     "kebab": 181,
  //     "kebabColor": "hsl(123, 70%, 50%)",
  //     "fries": 66,
  //     "friesColor": "hsl(242, 70%, 50%)",
  //     "donut": 48,
  //     "donutColor": "hsl(328, 70%, 50%)"
  //   },
  //   {
  //     "country": "AG",
  //     "hot dog": 36,
  //     "hot dogColor": "hsl(345, 70%, 50%)",
  //     "burger": 67,
  //     "burgerColor": "hsl(134, 70%, 50%)",
  //     "sandwich": 35,
  //     "sandwichColor": "hsl(81, 70%, 50%)",
  //     "kebab": 47,
  //     "kebabColor": "hsl(218, 70%, 50%)",
  //     "fries": 129,
  //     "friesColor": "hsl(206, 70%, 50%)",
  //     "donut": 40,
  //     "donutColor": "hsl(136, 70%, 50%)"
  //   },
  //   {
  //     "country": "AI",
  //     "hot dog": 1,
  //     "hot dogColor": "hsl(187, 70%, 50%)",
  //     "burger": 49,
  //     "burgerColor": "hsl(160, 70%, 50%)",
  //     "sandwich": 25,
  //     "sandwichColor": "hsl(290, 70%, 50%)",
  //     "kebab": 55,
  //     "kebabColor": "hsl(145, 70%, 50%)",
  //     "fries": 178,
  //     "friesColor": "hsl(205, 70%, 50%)",
  //     "donut": 76,
  //     "donutColor": "hsl(113, 70%, 50%)"
  //   },
  //   {
  //     "country": "AL",
  //     "hot dog": 198,
  //     "hot dogColor": "hsl(251, 70%, 50%)",
  //     "burger": 66,
  //     "burgerColor": "hsl(29, 70%, 50%)",
  //     "sandwich": 26,
  //     "sandwichColor": "hsl(260, 70%, 50%)",
  //     "kebab": 77,
  //     "kebabColor": "hsl(100, 70%, 50%)",
  //     "fries": 75,
  //     "friesColor": "hsl(96, 70%, 50%)",
  //     "donut": 96,
  //     "donutColor": "hsl(107, 70%, 50%)"
  //   },
  //   {
  //     "country": "AM",
  //     "hot dog": 57,
  //     "hot dogColor": "hsl(94, 70%, 50%)",
  //     "burger": 78,
  //     "burgerColor": "hsl(292, 70%, 50%)",
  //     "sandwich": 169,
  //     "sandwichColor": "hsl(181, 70%, 50%)",
  //     "kebab": 169,
  //     "kebabColor": "hsl(115, 70%, 50%)",
  //     "fries": 37,
  //     "friesColor": "hsl(335, 70%, 50%)",
  //     "donut": 116,
  //     "donutColor": "hsl(35, 70%, 50%)"
  //   }
  // ]

  const getSearchOverallShipmentSummary = async () => {
    const res = await api.get(
      `api/dashboard/overall-shipment-summary?startDate=${
        startDate ? moment(startDate).format("yyyy-MM-DD") : ""
      }&endDate=${
        endDate ? moment(endDate).format("yyyy-MM-DD") : ""
      }&transportGroupId=${board !== "all" ? board : ""}&inboundLocationId=${
        toInboundLocation !== "all" ? toInboundLocation : ""
      }&outboundLocationId=${
        toOutboundLocation !== "all" ? toOutboundLocation : ""
      }`
    );
    const data = await res.data;
    if (res.meta.status === true) {
      setOverallSummary(data);
    }
  };
  const getOverallShipmentSummary = async () => {
    const res = await api.get(
      `api/dashboard/overall-shipment-summary?startDate=${
        startDate ? moment(startDate).format("yyyy-MM-DD") : ""
      }&endDate=${endDate ? moment(endDate).format("yyyy-MM-DD") : ""}`
    );
    const data = await res.data;
    if (res.meta.status === true) {
      setOverallSummary(data);
    }
  };
  // const getSummary = async () => {
  //   const res = await api.get(
  //     `api/dashboard/summary?startDate=${startDate ? startDate : ""}&endDate=${
  //       endDate ? endDate : ""
  //     }`
  //   );
  //   const data = await res.data;
  //   if (res.meta.status === true) {
  //     setSummary(data);
  //   }
  // };
  // const getStockContainer = async () => {
  //   const res = await api.get(
  //     `api/dashboard/stockContainer?startDate=${
  //       startDate ? startDate : ""
  //     }&endDate=${endDate ? endDate : ""}`
  //   );
  //   const data = await res.data;
  //   if (res.meta.status === true) {
  //     setStockContainer(data);
  //   }
  // };
  // const getWorkOrder = async () => {
  //   const res = await api.get(
  //     `api/dashboard/workOrder?startDate=${
  //       startDate ? startDate : ""
  //     }&endDate=${endDate ? endDate : ""}`
  //   );
  //   const data = await res.data;
  //   if (res.meta.status === true) {
  //     setWorkOrder(data);
  //   }
  // };
  // const getOverallBooking = async () => {
  //   const res = await api.get(
  //     `api/dashboard/overallBooking?startDate=${
  //       startDate ? startDate : ""
  //     }&endDate=${endDate ? endDate : ""}`
  //   );
  //   const data = await res.data;
  //   if (res.meta.status === true) {
  //     setOverallBooking(data);
  //   }
  // };

  const getBarColor = (bar) => bar.data.color;
  const getCountry = async () => {
    try {
      const res = await api.get("api/country/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setCountry(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getLocation = async () => {
    try {
      const res = await api.get("api/location/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setLocation(data.filter((x) => x?.Status === true));
        setLocationOutboundFilter(data.filter((x) => x?.Status === true));
        setLocationInboundFilter(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    if (toOutboundCountry !== "all") {
      const filterLocation = location?.filter(
        (item) => item.CountryId === toOutboundCountry
      );
      setLocationOutboundFilter(filterLocation);
      setToOutboundLocation(filterLocation[0]?.LocationId);
    } else {
      setLocationOutboundFilter(location);
    }

    if (toInboundCountry !== "all") {
      const filterLocation = location?.filter(
        (item) => item.CountryId === toInboundCountry
      );
      setLocationInboundFilter(filterLocation);
      setToInboundLocation(filterLocation[0]?.LocationId);
    } else {
      setLocationInboundFilter(location);
    }
  }, [toOutboundCountry, toInboundCountry]);

  //api call
  // useEffect(() => {
  //   // GET request using axios inside useEffect React hook
  //   getSummary();
  //   getStockContainer();
  //   getWorkOrder();
  //   getOverallBooking();
  //   // empty dependency array means this effect will only run once (like componentDidMount in classes)
  // }, [startDate, endDate]);

  useEffect(() => {
    getOverallShipmentSummary();
    getCountry();
    getLocation();
  }, []);

  const getForecast = async () => {
    const res = await api.get(
      `api/financial/dashboard/forecast?year=${year ? year.getFullYear() : ""}`
    );
    const data = await res.data;
    if (res.meta.status === true) {
      setForecast(data);
    }
  };

  const getRevenueAndExpense = async () => {
    const res = await api.get(
      `api/financial/dashboard/revenueAndExpense?year=${
        value ? value.getFullYear() : ""
      }`
    );
    const data = await res.data;
    if (res.meta.status === true) {
      setRevenueAndExpense(data);
    }
  };
  const getRevenueByType = async () => {
    const res = await api.get(
      `api/financial/dashboard/revenueByType?date=${
        date ? moment(date).format("yyyy-MM-DD") : ""
      }`
    );
    const data = await res.data;
    if (res.meta.status === true) {
      setRevenueByType(data);
    }
  };
  //api call
  useEffect(() => {
    getForecast();
    // GET request using axios inside useEffect React hook
    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [year]);
  useEffect(() => {
    getRevenueAndExpense();
    // GET request using axios inside useEffect React hook
    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [value]);
  useEffect(() => {
    getRevenueByType();
    // GET request using axios inside useEffect React hook
    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [date]);

  const options = {
    chart: {
      type: "spline",
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    series: [
      {
        name: "ExtraExpenseAmount",
        data: revenueAndExpense?.map((x) => +x?.ExtraExpenseAmount.toFixed(2)),
      },
      {
        name: "AdvancePaymentAmount",
        data: revenueAndExpense?.map(
          (x) => +x?.AdvancePaymentAmount.toFixed(2)
        ),
      },
      {
        name: "CostAmount",
        data: revenueAndExpense?.map((x) => +x?.CostAmount.toFixed(2)),
      },
      {
        name: "IncomeAmount",
        data: revenueAndExpense?.map((x) => +x?.IncomeAmount.toFixed(2)),
      },
    ],

    credits: {
      enabled: false,
    },
  };
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h3 style={{ margin: "20px 0px" }} className="textcolorgreen">
          Welcome {userName || "-"}!
        </h3>

        {/* <Grid
          style={{ marginTop: "10px", display: "flex", flexDirection: "row" }}
          justifyContent="center"
        >
          <Card sx={{ maxWidth: 345, m: 2, boxShadow: 5, borderRadius: 2 }}>
            <CardContent>
              <div style={{ display: "flex" }}>
                <h6 style={{ color: "gray" }}>
                  Total Sale Order THB
                
                </h6>
              </div>
              <Typography>
                <h3>
                  {" "}
                  {summary?.TotalIncome
                    ? parseFloat(summary?.TotalIncome, 10)
                        .toFixed(2)
                        .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                    : "0"}
                </h3>
              </Typography>
            </CardContent>
          </Card>
          <Card sx={{ maxWidth: 345, m: 2, boxShadow: 5, borderRadius: 2 }}>
            <CardContent>
              <div style={{ display: "flex" }}>
                <h6 style={{ color: "gray" }}>
                  Total Sale Order QTY
                  
                </h6>
              </div>
              <Typography>
                <h3>
                  {" "}
                  {summary?.SaleOrderQty.toString().replace(
                    /(\d+)(\d{3})/,
                    "$1" + "," + "$2"
                  )}
                </h3>
              </Typography>
            </CardContent>
          </Card>
          <Card sx={{ maxWidth: 345, m: 2, boxShadow: 5, borderRadius: 2 }}>
            <CardContent>
              <div style={{ display: "flex" }}>
                <h6 style={{ color: "gray" }}>
                  New Client
                  
                </h6>
              </div>
              <Typography>
                <h3 style={{ color: "#00CC00" }}>
                  {" "}
                  {summary?.NewClient.toString().replace(
                    /(\d+)(\d{3})/,
                    "$1" + "," + "$2"
                  )}
                </h3>
              </Typography>
            </CardContent>
          </Card>
          <Card sx={{ maxWidth: 345, m: 2, boxShadow: 5, borderRadius: 2 }}>
            <CardContent>
              <div style={{ display: "flex" }}>
                <h6 style={{ color: "gray" }}>
                  Total Expense THB

                </h6>
              </div>
              <Typography>
                <h3 style={{ color: "#d03366" }}>
                  {" "}
                  {summary?.TotalExpense
                    ? parseFloat(summary?.TotalExpense, 10)
                        .toFixed(2)
                        .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                    : "0"}
                </h3>
              </Typography>
            </CardContent>
          </Card>
        </Grid> */}

        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12}>
            <Card variant="outlined" sx={{ p: 2 }}>
              {/* <h6 style={{ color: "gray" }}>Inactive Container </h6>
              <div style={{ height: 300 }}>
                <ChartContainer stockContainer={stockContainer} />
              </div> */}
              <Grid container alignItems="center" spacing={1} columns={21}>
                <Grid item lg={3} sm={10.5} xs={21}>
                  <FormControl
                    size="small"
                    sx={{
                      width: "100%",
                    }}
                  >
                    <InputLabel>Outbound Country</InputLabel>
                    <Select
                      label="Outbound Country"
                      value={toOutboundCountry}
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) => {
                        setToOutboundCountry(e.target.value);
                      }}
                      // disabled={values.liners !== ""}
                    >
                      <MenuItem value={"all"}>ทั้งหมด</MenuItem>
                      {country?.map((x) => (
                        <MenuItem value={x?.CountryId}>
                          {x?.CountryName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={3} sm={10.5} xs={21}>
                  <FormControl
                    size="small"
                    sx={{
                      width: "100%",
                    }}
                  >
                    <InputLabel>Outbound Location</InputLabel>
                    <Select
                      label="Outbound Location"
                      value={toOutboundLocation}
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) => {
                        setToOutboundLocation(e.target.value);
                      }}
                      // disabled={values.liners !== ""}
                    >
                      <MenuItem value={"all"}>ทั้งหมด</MenuItem>
                      {locationOutboundFilter?.map((x) => (
                        <MenuItem value={x?.LocationId}>
                          {x?.LocationName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={1} sm={21} xs={21}>
                  <Typography sx={{ margin: "0px 20px" }}>-</Typography>
                </Grid>
                <Grid item lg={3} sm={10.5} xs={21}>
                  <FormControl
                    size="small"
                    sx={{
                      width: "100%",
                    }}
                  >
                    <InputLabel>Inbound Country</InputLabel>
                    <Select
                      label="Inbound Country"
                      value={toInboundCountry}
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) => {
                        setToInboundCountry(e.target.value);
                      }}
                      // disabled={values.liners !== ""}
                    >
                      <MenuItem value={"all"}>ทั้งหมด</MenuItem>
                      {country?.map((x) => (
                        <MenuItem value={x?.CountryId}>
                          {x?.CountryName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={3} sm={10.5} xs={21}>
                  <FormControl
                    size="small"
                    sx={{
                      width: "100%",
                    }}
                  >
                    <InputLabel>Inbound Location</InputLabel>
                    <Select
                      label="Inbound Location"
                      value={toInboundLocation}
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) => {
                        setToInboundLocation(e.target.value);
                      }}
                      // disabled={values.liners !== ""}
                    >
                      <MenuItem value={"all"}>ทั้งหมด</MenuItem>
                      {locationInboundFilter?.map((x) => (
                        <MenuItem value={x?.LocationId}>
                          {x?.LocationName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={2} sm={10.5} xs={21}>
                  <FormControl
                    size="small"
                    sx={{
                      width: "100%",
                    }}
                  >
                    <InputLabel>Board</InputLabel>
                    <Select
                      label="Board"
                      value={board}
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) => {
                        setBoard(e.target.value);
                      }}
                      // disabled={values.liners !== ""}
                    >
                      <MenuItem value={"all"}>ทั้งหมด</MenuItem>
                      {["Truck", "Train", "Ship"]?.map((x) => (
                        <MenuItem value={x}>{x}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Grid item lg={2.5} sm={10.5} xs={21}>
                    <DesktopDatePicker
                      label="Date Start"
                      value={startDate}
                      inputFormat="yyyy/MM/dd"
                      // minDate={new Date("2017-01-01")}
                      onChange={(newValue) => {
                        setStartDate(moment(newValue).format("yyyy-MM-DD"));
                      }}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          style={{ width: "100%" }}
                          {...params}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item lg={2.5} sm={10.5} xs={21}>
                    <DesktopDatePicker
                      label="Date End"
                      value={endDate}
                      inputFormat="yyyy/MM/dd"
                      minDate={new Date(startDate)}
                      onChange={(newValue) => {
                        setEndDate(moment(newValue).format("yyyy-MM-DD"));
                      }}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          style={{
                            width: "100%",
                          }}
                          {...params}
                        />
                      )}
                    />
                  </Grid>
                </LocalizationProvider>
                <Grid item lg={1} sm={10.5} xs={21}>
                  <Button
                    style={{
                      backgroundColor: "#0d6efd",
                      color: "#fafafa",
                    }}
                    onClick={() => getSearchOverallShipmentSummary()}
                  >
                    <SearchIcon />
                  </Button>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item lg={8}>
                  <h5 style={{ color: "gray", margin: "20px 0px" }}>
                    Active Shipments
                  </h5>
                  <Grid container>
                    <Grid item xs={6} sx={{ display: "flex", gap: "10px" }}>
                      <img src={icon1} style={{ width: "120px" }} />
                      <div>
                        <Typography variant="h5">Shipments</Typography>
                        <Typography variant="h6">
                          {overallSummary?.ActiveShipments?.TotalShipments?.toLocaleString()}{" "}
                          BKG
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={6} sx={{ display: "flex", gap: "10px" }}>
                      <img src={icon2} style={{ width: "120px" }} />
                      <div>
                        <Typography variant="h5">Containers</Typography>
                        <Typography variant="h6">
                          {overallSummary?.ActiveShipments?.TotalContainers?.toLocaleString()}{" "}
                          TEU
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container sx={{ margin: "40px 0px" }}>
                    <Grid item xs={2.4}>
                      <img src={icon2} style={{ width: "80px" }} />
                      <div>
                        <Typography variant="h5">Empty Pickup</Typography>
                        <Typography>
                          {overallSummary?.ActiveShipments?.EmptyPickup?.Shipments?.toLocaleString()}{" "}
                          BKG /{" "}
                          {overallSummary?.ActiveShipments?.EmptyPickup?.Containers?.toLocaleString()}{" "}
                          TEU
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={2.4}>
                      <img src={icon3} style={{ width: "80px" }} />
                      <div>
                        <Typography variant="h6">Cargo Loading</Typography>
                        <Typography>
                          {overallSummary?.ActiveShipments?.CargoLoading?.Shipments?.toLocaleString()}{" "}
                          BKG /{" "}
                          {overallSummary?.ActiveShipments?.CargoLoading?.Containers?.toLocaleString()}{" "}
                          TEU
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={2.4}>
                      <img src={icon4} style={{ width: "80px" }} />
                      <div>
                        <Typography variant="h6">Full Return</Typography>
                        <Typography>
                          {overallSummary?.ActiveShipments?.FullReturn?.Shipments?.toLocaleString()}{" "}
                          BKG /{" "}
                          {overallSummary?.ActiveShipments?.FullReturn?.Containers?.toLocaleString()}{" "}
                          TEU
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={2.4}>
                      <img src={icon5} style={{ width: "80px" }} />
                      <div>
                        <Typography variant="h6">Load on Board</Typography>
                        <Typography>
                          {overallSummary?.ActiveShipments?.LoadOnBoard?.Shipments?.toLocaleString()}{" "}
                          BKG /{" "}
                          {overallSummary?.ActiveShipments?.LoadOnBoard?.Containers?.toLocaleString()}{" "}
                          TEU
                        </Typography>
                      </div>
                    </Grid>
                    {/* งานครึ่งเดียวขาเข้า (One-Way Import): unload แล้วตู้เปล่ากลับลาน = จบงาน (ไม่ค้างที่ Empty Pickup) */}
                    <Grid item xs={2.4}>
                      <img src={icon1} style={{ width: "80px" }} />
                      <div>
                        <Typography variant="h6">Completed</Typography>
                        <Typography>
                          {overallSummary?.ActiveShipments?.Completed?.Shipments?.toLocaleString()}{" "}
                          BKG /{" "}
                          {overallSummary?.ActiveShipments?.Completed?.Containers?.toLocaleString()}{" "}
                          TEU
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                  <Divider />
                  <h5 style={{ color: "gray", margin: "20px 0px" }}>
                    To Do List
                  </h5>
                  <Grid container sx={{ margin: "20px 0px" }}>
                    <Grid item xs={4}>
                      <div>
                        <Typography variant="h6">
                          Container Required{" "}
                        </Typography>
                        <Typography>
                          {overallSummary?.ToDoList?.ContainerRequired?.toLocaleString()}{" "}
                          BKG
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <div>
                        <Typography variant="h6">
                          Container Repaired{" "}
                        </Typography>
                        <Typography>
                          {overallSummary?.ToDoList?.ContainerRepaired?.toLocaleString()}{" "}
                          UNIT
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <div>
                        <Typography variant="h6">SI Required</Typography>
                        <Typography>
                          {overallSummary?.ToDoList?.SIRequired?.toLocaleString()}{" "}
                          BKG{" "}
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                  <Divider />
                  <h5 style={{ color: "gray", margin: "20px 0px" }}>
                    Shipment Plan{" "}
                  </h5>
                  <Grid container columns={10}>
                    <Grid item xs={2}>
                      <div>
                        <Typography variant="h6">Cancel Shipment</Typography>
                        <Typography>
                          {overallSummary?.ShipmentPlan?.CancelShipment?.toLocaleString()}{" "}
                          BKG
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={2}>
                      <div>
                        <Typography variant="h6">New Order</Typography>
                        <Typography>
                          {overallSummary?.ShipmentPlan?.NewOrder?.toLocaleString()}{" "}
                          BKG
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={2}>
                      <div>
                        <Typography variant="h6">Processing</Typography>
                        <Typography>
                          {overallSummary?.ShipmentPlan?.Processing?.toLocaleString()}{" "}
                          BKG{" "}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={2}>
                      <div>
                        <Typography variant="h6">Confirm</Typography>
                        <Typography>
                          {overallSummary?.ShipmentPlan?.Confirm?.toLocaleString()}{" "}
                          BKG{" "}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={2}>
                      <div>
                        <Typography variant="h6">Complete</Typography>
                        <Typography>
                          {overallSummary?.ShipmentPlan?.Complete?.toLocaleString()}{" "}
                          BKG{" "}
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={4} sx={{ display: "flex" }}>
                  <Divider
                    orientation="vertical"
                    variant="middle"
                    flexItem
                    style={{ height: "100%" }}
                  />
                  <div
                    style={{
                      marginLeft: "15px",
                    }}
                  >
                    <h5 style={{ color: "gray", margin: "20px 0px" }}>
                      Cargo Tracking
                    </h5>
                    <Grid container sx={{ margin: "20px 0px" }}>
                      <Grid item xs={12}>
                        <div style={{ display: "flex" }}>
                          <TextField
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <SearchIcon />
                                </InputAdornment>
                              ),
                              disableUnderline: true,
                            }}
                            label="Search"
                            onChange={(e) => setKey(e.target.value)}
                            size="small"
                          />

                          <Button
                            variant="outlined"
                            style={{
                              color: "#84BD5A",
                              borderColor: "#84BD5A",
                              marginLeft: "10px",
                            }}
                            onClick={() =>
                              history.push({
                                pathname: "/Planner/CargoTracking",
                                state: {
                                  // location state
                                  key: key,
                                },
                              })
                            }
                          >
                            ค้นหา
                          </Button>
                        </div>
                      </Grid>
                    </Grid>
                    <Divider />
                    <h5 style={{ color: "gray", margin: "20px 0px" }}>
                      Cargo Flow
                    </h5>
                    <Grid container columns={12}>
                      {overallSummary?.CargoFlow?.map((item) => {
                        return (
                          <>
                            <Grid item xs={9}>
                              <Typography>
                                {`${item?.LocationFrom} - ${item?.LocationTo}`}
                              </Typography>
                            </Grid>
                            <Grid item xs={3}>
                              <Typography sx={{ textAlign: "end" }}>
                                {item?.TEU?.toLocaleString()} TEU
                              </Typography>
                            </Grid>
                          </>
                        );
                      })}
                    </Grid>
                  </div>
                </Grid>
              </Grid>

              <Divider sx={{ margin: "20px 0px" }} />

              <h4>Overall Bookings </h4>
              <h6 style={{ color: "gray" }}>By Month </h6>
              <div style={{ height: 600 }}>
                <HighchartsReact
                  highcharts={Highcharts}
                  options={{
                    chart: {
                      type: "column",
                      height: 600,
                    },

                    title: {
                      text: null,
                      align: "left",
                    },
                    xAxis: {
                      categories: overallSummary?.OverAll?.map(
                        (x) => x?.MonthName + " " + x?.Year
                      ),
                    },
                    yAxis: {
                      min: 0,
                      title: {
                        text: null,
                      },
                      stackLabels: {
                        enabled: true,
                        style: {
                          fontWeight: "bold",
                          color:
                            // theme
                            (Highcharts.defaultOptions.title.style &&
                              Highcharts.defaultOptions.title.style.color) ||
                            "gray",
                          textOutline: "none",
                        },
                      },
                    },
                    tooltip: {
                      headerFormat: "<b>{point.x}</b><br/>",
                      pointFormat:
                        "{series.name}: {point.y}<br/>Total: {point.stackTotal}",
                    },
                    plotOptions: {
                      column: {
                        stacking: "normal",
                        dataLabels: {
                          enabled: true,
                        },
                      },
                    },
                    series: [
                      {
                        name: "Truck",
                        data: overallSummary?.OverAll?.filter(
                          (v) => v?.Truck > 0
                        )?.map((x) => x?.Truck),
                      },
                      {
                        name: "Train",
                        data: overallSummary?.OverAll?.filter(
                          (v) => v?.Train > 0
                        )?.map((x) => x?.Train),
                      },
                      {
                        name: "Ship",
                        data: overallSummary?.OverAll?.filter(
                          (v) => v?.Ship > 0
                        )?.map((x) => x?.Ship),
                      },
                      {
                        name: "Repair",
                        data: overallSummary?.OverAll?.filter(
                          (v) => v?.Repair > 0
                        )?.map((x) => x?.Repair),
                      },
                    ],
                  }}
                />
              </div>
            </Card>
          </Grid>
          {/* <Grid item xs={4}>
            <Card variant="outlined" sx={{ p: 2 }}>
              <div style={{ display: "flex" }}>
                <h6 style={{ color: "gray" }}>WORK ORDER </h6>
              </div>
              <List
                sx={{ width: "100%" }}
                component="nav"
                aria-label="main mailbox folders"
              >
                <ListItem>
                  <ListItemIcon>
                    <span
                      style={{ marginRight: 10 }}
                      className="material-icons-outlined"
                    >
                      local_shipping
                    </span>
                  </ListItemIcon>
                  <ListItemText primary="TRUCK" />
                  <h5>
                    {workOrder?.Truck?.toString().replace(
                      /(\d+)(\d{3})/,
                      "$1" + "," + "$2"
                    )}
                  </h5>
                </ListItem>

                <Divider />
                <ListItem>
                  <ListItemIcon>
                    <span
                      style={{ marginRight: 10 }}
                      className="material-icons-outlined"
                    >
                      train
                    </span>
                  </ListItemIcon>
                  <ListItemText primary="TRAIN" />
                  <h5>
                    {workOrder?.Train?.toString().replace(
                      /(\d+)(\d{3})/,
                      "$1" + "," + "$2"
                    )}
                  </h5>
                </ListItem>
                <Divider />
                <ListItem>
                  <ListItemIcon>
                    <span
                      style={{ marginRight: 10 }}
                      className="material-icons-outlined"
                    >
                      directions_boat
                    </span>
                  </ListItemIcon>
                  <ListItemText primary="SHIP" />
                  <h5>
                    {workOrder?.Ship?.toString().replace(
                      /(\d+)(\d{3})/,
                      "$1" + "," + "$2"
                    )}
                  </h5>
                </ListItem>
                <Divider />
                <ListItem>
                  <ListItemIcon>
                    <span
                      style={{ marginRight: 10 }}
                      className="material-icons-outlined"
                    >
                      construction
                    </span>
                  </ListItemIcon>
                  <ListItemText primary="REPIAR" />
                  <h5>
                    {workOrder?.Repair?.toString().replace(
                      /(\d+)(\d{3})/,
                      "$1" + "," + "$2"
                    )}
                  </h5>
                </ListItem>
                <Divider />
              </List>
            </Card>
          </Grid> */}
        </Grid>
        <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
          <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
            Payment
          </h6>

          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={4}>
              <Card variant="outlined" sx={{ p: 2 }}>
                <Grid container spacing={2} columns={16}>
                  <Grid item xs={8}>
                    <h4>Forecasting </h4>
                    <h6 style={{ color: "gray" }}>ประมาณการรายได้ </h6>
                  </Grid>
                  <Grid item xs={8}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <Stack spacing={3}>
                        <DatePicker
                          views={["year"]}
                          label="Year only"
                          value={year}
                          onChange={(newValue) => {
                            setYear(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              style={{ width: "150px" }}
                              helperText={null}
                            />
                          )}
                        />
                      </Stack>
                    </LocalizationProvider>
                  </Grid>
                </Grid>

                <div style={{ marginTop: 10, height: 400 }}>
                  <HighchartsReact
                    highcharts={Highcharts}
                    options={{
                      chart: {
                        type: "column",
                      },
                      title: {
                        text: null,
                      },
                      xAxis: {
                        categories: [
                          "Jan",
                          "Feb",
                          "Mar",
                          "Apr",
                          "May",
                          "Jun",
                          "Jul",
                          "Aug",
                          "Sep",
                          "Oct",
                          "Nov",
                          "Dec",
                        ],
                      },
                      yAxis: {
                        title: {
                          text: null,
                        },
                      },

                      series: [
                        {
                          type: "column",
                          name: "Amount",
                          colorByPoint: true,
                          data: forecast?.map(
                            (x) => +x?.ForecastAmount.toFixed(2)
                          ),
                          showInLegend: false,
                        },
                      ],
                      credits: {
                        enabled: false,
                      },
                    }}
                  />
                </div>
              </Card>
            </Grid>
            <Grid item xs={8}>
              <Card variant="outlined" sx={{ p: 2 }}>
                <Grid container spacing={2} columns={16}>
                  <Grid item xs={8}>
                    <h4>Revenues - Expenses </h4>
                    <h6 style={{ color: "gray" }}>รายได้ - ค่าใช้จ่าย </h6>
                  </Grid>
                  <Grid item xs={8}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <Stack spacing={3}>
                        <DatePicker
                          views={["year"]}
                          label="Year only"
                          value={value}
                          onChange={(newValue) => {
                            setValue(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField
                              size="small"
                              {...params}
                              style={{ width: "150px" }}
                              helperText={null}
                            />
                          )}
                        />
                      </Stack>
                    </LocalizationProvider>
                  </Grid>
                </Grid>
                <div style={{ height: 400 }}>
                  {/* <LineChart revenueAndExpense={revenueAndExpense} /> */}
                  <HighchartsReact highcharts={Highcharts} options={options} />
                </div>
              </Card>
            </Grid>
          </Grid>

          <Grid sx={{ mt: 2 }} xs={12}>
            <Card variant="outlined" sx={{ p: 2 }}>
              <Grid container spacing={2} columns={16}>
                <Grid item xs={8}>
                  <h4>Realized Revenue </h4>
                  <h6 style={{ color: "gray" }}>รายได้แยกตามประเภท </h6>
                </Grid>
                <Grid item xs={8}>
                  <div style={{ display: "flex" }}>
                    {/* <FormControl sx={{ width: 200, mr: 5 }}>
                    <InputLabel id="demo-simple-select-label">TYPE</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={type}
                      label="TYPE"
                      onChange={handleChange}
                    >
                      <MenuItem value={10}>Ten</MenuItem>
                      <MenuItem value={20}>Twenty</MenuItem>
                      <MenuItem value={30}>Thirty</MenuItem>
                    </Select>
                  </FormControl> */}
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <Stack spacing={3}>
                        <DatePicker
                          views={["month", "year"]}
                          label="Month Year"
                          value={date}
                          onChange={(newValue) => {
                            setDate(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              style={{ width: "150px" }}
                              size="small"
                              helperText={null}
                            />
                          )}
                        />
                      </Stack>
                    </LocalizationProvider>
                  </div>
                </Grid>
              </Grid>

              <div>
                <HighchartsReact
                  highcharts={Highcharts}
                  options={{
                    chart: {
                      type: "column",
                    },
                    title: {
                      text: null,
                    },
                    xAxis: {
                      categories: ["Ship", "Train", "Truck"],
                    },
                    yAxis: {
                      title: {
                        text: null,
                      },
                    },
                    plotOptions: {
                      column: {
                        stacking: "normal",
                        dataLabels: {
                          enabled: true,
                        },
                      },
                    },
                    series: [
                      {
                        type: "column",
                        name: "Amount",
                        colorByPoint: true,
                        data: revenueByType?.map((x) => {
                          return {
                            name: x?.Type,
                            y: +x?.RevemueAmount.toFixed(2),
                            drilldown: x?.Type,
                          };
                        }),
                        showInLegend: false,
                      },
                    ],
                    credits: {
                      enabled: false,
                    },
                  }}
                />
              </div>
            </Card>
          </Grid>
        </Card>
      </Card>
    </div>
  );
}
